import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { DirectService, PropertySearchWidget } from '../../services/direct.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-edit-mps-widget',
  templateUrl: './direct-edit-mps-widget.component.html',
  styleUrls: ['./direct-edit-mps-widget.component.scss'],
})
export class DirectEditMpsWidgetComponent implements OnInit {
  @Input() parentType: 'internal' | 'custom';
  @Input() parentId: string;

  widget!: PropertySearchWidget;
  saving = false;
  resultsPageUrl = '/search';

  constructor(
    public directEditService: DirectEditService,
    private route: ActivatedRoute,
    private direct: DirectService
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      // Don't overwrite the input if we have nothing in the route data
      if (data.parentType) {
        this.parentType = data.parentType;
      }
    });

    if (!this.parentId) {
      // If we dont have a parentId from the input, use the site ID from the direct edit service
      // Added as a quick fix to resolve custom site issues in DIR-2595
      this.parentId = this.directEditService.site.id;
    }

    this.direct.getPropertySearchWidgetDetails(this.parentId, this.parentType).subscribe((res) => {
      this.widget = res;
    });
  }

  save() {
    this.saving = true;
    this.direct.updatePropertySearchWidget(this.parentId, this.parentType, this.widget).subscribe(
      () => (this.saving = false),
      () => (this.saving = false)
    );
  }
}
